export const SIMULATION_DETAILS_VIEW = Object.freeze({
                                                 text: 'Details',
                                                 id: 'detailsView',
                                               });

export const SIMULATION_VALIDATION_VIEW = Object.freeze({
                                                       text: 'Validation',
                                                       id: 'validationsView',
                                                     });

export const SIMULATOR_VIEW_SEGMENTS = [SIMULATION_DETAILS_VIEW, SIMULATION_VALIDATION_VIEW];

export const ERROR_MESSAGE = 'Error: changes may not have been saved. Please refresh the page and try again.';



// WEBPACK FOOTER //
// ./src/constants/views.jsx